import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export type AtelierConfig = {
  dayStartHour: number;
  dayEndHour: number;
  closedDays: number[]; // 0=dimanche … 6=samedi
};

/**
 * Config atelier (horaires + jours fermés) — alimente le formulaire RDV pour
 * borner l'agenda et bloquer les jours fermés. Endpoint accessible à tous les
 * rôles connectés. Change rarement → staleTime large.
 */
export function useAtelierConfig() {
  return useQuery({
    queryKey: ['atelier-config'],
    queryFn: () => api.get<{ config: AtelierConfig }>('/atelier-config'),
    select: (d) => d.config,
    staleTime: 5 * 60_000,
  });
}
